import notoSansJp400 from '@/styles/fonts/noto-sans-jp-japanese-400-normal.woff2?url'
import notoSansJp700 from '@/styles/fonts/noto-sans-jp-japanese-700-normal.woff2?url'
import notoSansKr400 from '@/styles/fonts/noto-sans-kr-korean-400-normal.woff2?url'
import notoSansKr700 from '@/styles/fonts/noto-sans-kr-korean-700-normal.woff2?url'
import notoSansSc400 from '@/styles/fonts/noto-sans-sc-chinese-simplified-400-normal.woff2?url'
import notoSansSc700 from '@/styles/fonts/noto-sans-sc-chinese-simplified-700-normal.woff2?url'

import type { AppLocale } from '../types/Locale'

const CJK_FONT_FAMILY = 'NotoSansCJK'

interface CjkFontSource {
  url: string
  weight: string
}

const CJK_FONT_SOURCES: Partial<Record<AppLocale, CjkFontSource[]>> = {
  zh: [
    { url: notoSansSc400, weight: '400' },
    { url: notoSansSc700, weight: '700' },
  ],
  ja: [
    { url: notoSansJp400, weight: '400' },
    { url: notoSansJp700, weight: '700' },
  ],
  ko: [
    { url: notoSansKr400, weight: '400' },
    { url: notoSansKr700, weight: '700' },
  ],
}

export function getCjkFontSources(locale: AppLocale): CjkFontSource[] {
  return CJK_FONT_SOURCES[locale] ?? []
}

let activeLocale: AppLocale | undefined
let activeFaces: FontFace[] = []

export function loadCjkFont(locale: AppLocale): void {
  if (activeLocale === locale) {
    return
  }
  activeLocale = locale

  try {
    activeFaces.forEach((face) => document.fonts.delete(face))
    activeFaces = getCjkFontSources(locale).map(
      ({ url, weight }) =>
        new FontFace(CJK_FONT_FAMILY, `url(${url}) format('woff2')`, {
          weight,
          display: 'swap',
        }),
    )
    activeFaces.forEach((face) => document.fonts.add(face))
  } catch (error) {
    console.warn('Failed to register the CJK font', error)
  }
}
